var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.99996 17.3337C7.35178 17.3337 5.74062 16.8449 4.37021 15.9292C2.9998 15.0136 1.9317 13.7121 1.30097 12.1894C0.670237 10.6666 0.505209 8.99108 0.826752 7.37458C1.1483 5.75807 1.94197 4.27321 3.10741 3.10777C4.27284 1.94234 5.7577 1.14866 7.37421 0.827119C8.99072 0.505575 10.6663 0.670603 12.189 1.30133C13.7117 1.93206 15.0132 3.00017 15.9289 4.37058C16.8446 5.74099 17.3333 7.35215 17.3333 9.00033C17.3309 11.2097 16.4522 13.328 14.8899 14.8902C13.3276 16.4525 11.2094 17.3313 8.99996 17.3337ZM8.99996 2.05588C7.62648 2.05588 6.28384 2.46317 5.14184 3.22623C3.99983 3.9893 3.10974 5.07387 2.58413 6.3428C2.05852 7.61174 1.921 9.00803 2.18895 10.3551C2.45691 11.7022 3.1183 12.9396 4.0895 13.9108C5.0607 14.882 6.29808 15.5434 7.64517 15.8113C8.99226 16.0793 10.3886 15.9418 11.6575 15.4162C12.9264 14.8905 14.011 14.0005 14.7741 12.8585C15.5371 11.7164 15.9444 10.3738 15.9444 9.00033C15.9424 7.15917 15.2101 5.394 13.9082 4.0921C12.6063 2.7902 10.8411 2.05791 8.99996 2.05588Z",
    fill: "#57689F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.38969 11.5007L5.66663 10.3226L8.4703 8.53267V4.83398H9.83329V9.30228L6.38969 11.5007Z",
    fill: "#57689F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHours);
export default __webpack_public_path__ + "static/media/hours.a3f596efbeb3de6e80410c12607bc69e.svg";
export { ForwardRef as ReactComponent };